import React from "react";
import { EditOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import { useSupporterEdit } from "hook/supporters/useSupporter";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableEdit = ({ data }) => {
  // -------------------------- VAR -----------------------------
  const { handleOpenEdit } = useSupporterEdit();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Sửa Quyền">
      <Button
        onClick={() => handleOpenEdit(data)}
        icon={<EditOutlined />}
        type="text"
        shape="circle"
      />
    </Tooltip>
  );
};
export default TableEdit;
